import { errorMessage } from "@/Components/BifrostDeviceDetailsComponents/DirectTunnelSettings/store/errorMessage"
import { useAuth0 } from "@auth0/auth0-react"
import { useReducer } from "react"
import { useParams } from "react-router-dom"
import { removeSubnetMappingModalReducer, removeSubnetMappingModalState } from "../reducers"

export const useRemoveSubnetMappingModal = (refresh, item) => {
	const [state, dispatch] = useReducer(removeSubnetMappingModalReducer, removeSubnetMappingModalState)
	const { getAccessTokenSilently } = useAuth0()
	const { id } = useParams()

	const openRemoveSubnetMappingModal = () => {
		dispatch({ type: "OPEN_REMOVE_SUBNET_MAPPING_MODAL" })
		dispatch({
			type: "SET_REQUEST_DATA", payload: {
				"user_peer_col": [
					{
						"auth0_user_id": item.id,
						"user_name": item.name,
						"email": item.email,
						"peers": item.peers
					}
				],
				"network_mapping": item.subnet,
				"status": item.status,
				"mode": item.mode,
				"activated_time": item.activation === "N/A" ? null : item.activation,
				"deactivated_time": item.deactivation === "N/A" ? null : item.deactivation,
				"reason": item.reason
			}
		})
	}

	const closeRemoveSubnetMappingModal = () => {
		dispatch({ type: "CLOSE_REMOVE_SUBNET_MAPPING_MODAL" })
	}

	const setMouseHover = (index) => {
		dispatch({ type: "SET_MOUSE_HOVER", payload: index })
	}

	const confirmRemoveSubnetMapping = async () => {
		dispatch({ type: "IS_LOADING" })
		fetch(
			new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/device/directTunnel/" + id + "/SubnetMapping", {
				method: "DELETE",
				headers: new Headers({
					"Authorization": "Bearer " + (await getAccessTokenSilently()),
					"Content-Type": "application/json"
				}),
				body: JSON.stringify(state.requestData)
			})
		)
			.then((response) => {
				if (response.status === 202) {
					dispatch({ type: "REMOVE_SUBNET_MAPPING_SUCCESS" })
					refresh()
				} else {
					return response.json()
				}
			})
			.then((result) => {
				switch (result.code) {
					case 6:
						throw new Error(errorMessage.ROUTE_NOT_FOUND)
					case null:
						break
					default:
						throw new Error(errorMessage.NOT_ALLOWED_REMOVE)
				}
			})
			.catch((err) => {
				dispatch({ type: "REMOVE_SUBNET_MAPPING_ERROR", payload: err.message })
			})
	}

	const errorHandler = () => {
		closeRemoveSubnetMappingModal()
		refresh()
	}

	return {
		state,
		openRemoveSubnetMappingModal,
		closeRemoveSubnetMappingModal,
		setMouseHover,
		confirmRemoveSubnetMapping,
		errorHandler
	}
}
